import { styled } from '@material-ui/core/styles';

export const Container = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.primary.FP50,
  padding: theme.spacing(1, 2),
  position: 'sticky',
  top: 0,
  zIndex: theme.zIndex.stickyHeader,

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}));
